// Lazy, isolated Firebase Web SDK init for AI Logic via CDN ESM.
// Only imports firebase-app + firebase-ai. No Analytics/Auth/etc.

const CDN_BASE = 'https://www.gstatic.com/firebasejs/12.1.0';
const APP_NAME = 'rezident-ai';
const RECAPTCHA_ENTERPRISE_SITE_KEY = '6Ldp1rwrAAAAAMpQllQcqXB44AVkmw0xDvgkWy9S'; // App Check site key

// Keep the Web SDK config fully here (isolated from Kotlin)
const CONFIG = {
    apiKey: "AIzaSyDcfN_YlDZVd-dQiyU02FiiLQncPj3ycYo",
    authDomain: "rezident.info",
    projectId: "rezident-info",
    storageBucket: "rezident-info.firebasestorage.app",
    messagingSenderId: "701270043234",
    appId: "1:701270043234:web:852d50a5021cb637343f3b",
};

let aiInstance = null;

async function initFirebaseAi() {
    if (aiInstance) return;

    const {initializeApp, getApp, getApps} = await import(/* webpackIgnore: true */ `${CDN_BASE}/firebase-app.js`);
    const existing = getApps().find((a) => a.name === APP_NAME);
    const app = existing ? getApp(APP_NAME) : initializeApp(CONFIG, APP_NAME);

    // Initialize App Check with reCAPTCHA Enterprise BEFORE using other Firebase services
    // Docs: https://firebase.google.com/docs/app-check/web/recaptcha-enterprise-provider
    try {
        const {
            initializeAppCheck,
            ReCaptchaEnterpriseProvider
        } = await import(/* webpackIgnore: true */ `${CDN_BASE}/firebase-app-check.js`);
        initializeAppCheck(app, {
            provider: new ReCaptchaEnterpriseProvider(RECAPTCHA_ENTERPRISE_SITE_KEY),
            isTokenAutoRefreshEnabled: true,
        });
    } catch (err) {
        // Fail-safe: do not block AI init if App Check fails to initialize
        console.warn('App Check init failed:', err);
    }

    const {getAI, GoogleAIBackend} = await import(/* webpackIgnore: true */ `${CDN_BASE}/firebase-ai.js`);
    aiInstance = getAI(app, {backend: new GoogleAIBackend()});
}

async function generateText(modelName, prompt) {
    if (!aiInstance) throw new Error('Firebase AI not initialized. Call initFirebaseAi first.');
    const {getGenerativeModel} = await import(/* webpackIgnore: true */ `${CDN_BASE}/firebase-ai.js`);
    // Configure longer timeout for large batch requests (default is 180s)
    // Extend to 240s (4 minutes) to handle complex AI generation tasks
    const model = getGenerativeModel(aiInstance, {model: modelName}, {timeout: 240000});
    const result = await model.generateContent(prompt);
    return result.response.text();
}

module.exports = {
    initFirebaseAi,
    generateText,
};